import { network } from 'services/network';

export const setReportFavoriteStatus = (params: QueryParams): Promise<QueryResponse> => {
    const url = `api/bo/reporting/setReportFavoriteStatus`;
    return network.post(url, params).then((response) => {
        return response.data;
    });
};
export interface QueryParams {
    reportId: number;
    status: boolean;
}

export interface QueryResponse {
    id: number;
    status: boolean;
}
